import { NgModule } from '@angular/core';

import { TimeDiffPipe } from './time-diff.pipe';

@NgModule({
  declarations: [
    TimeDiffPipe,
  ],
  exports: [
    TimeDiffPipe,
  ],
})
export class TimeDiffModule { }
